import { Team } from '@ori/testid-generator';

/**
 * Name of this app.
 */
export const APP_NAME = 'language-switcher';

/**
 * Team which owns this SPA.
 */
export const APP_TEAM_NAME: Team = Team.Framework;

/**
 * Serves as identifier to the root of this SPA in the HTML:
 */
export const ROOT_ELEMENT_ID = 'language-switcher-root';

/**
 * Name of the cookie we want to store current selected language.
 */
export const LANGUAGE_COOKIE_KEY = 'lang';

/**
 * Options to be used when setting cookies.
 */
export const LANGUAGE_COOKIE_OPTIONS = {
  expires: 365, // days
};
